import Immutable from 'immutable';

import TypeInfo from 'sharedreact/data/TypeInfo';

const Content: {
  id: string,
  name: string,
  value: string,
  typeInfo: TypeInfo | null,
  parentId: string,
  parentName: string
} = {
  id: '',
  name: '',
  value: '',
  typeInfo: null,
  parentId: '',
  parentName: ''
};

class Parameter extends Immutable.Record(Content) {
}


export default Parameter;
